<mat-form-field [matMenuTriggerFor]="dateRangeMenu">
<mat-label>{{ 'orders.grid.dateRange.label' | translate }}</mat-label>
<mat-date-range-input>
    <input matStartDate
           readonly
           [value]="convertToDate(dateRange.start)" />
    <input matEndDate
           readonly
           [value]="convertToDate(dateRange.end)" />
</mat-date-range-input>
<i *ngIf="!dateRange.start" matSuffix>▾</i>
    <button mat-button
            *ngIf="dateRange.start"
            matSuffix
            aria-label="Clear"
            (click)="clearDateRange()">
        <i class="tce-icon-close"></i>
    </button>
  <mat-hint>{{ 'orders.grid.dateRange.hint' | translate }}</mat-hint>
  <mat-menu class="daterange-menu"
            #dateRangeMenu="matMenu"
            (close)="clearTempDateRange()">
    <div class="container" (click)="$event.stopPropagation()">
    <div class="presets">
        <h4>{{ 'orders.grid.dateRange.rangePresets' | translate }}</h4>
        <mat-button-toggle-group (change)="setDateRange($event)"
                                 [(value)]="tempDateRangePreset" vertical>
            <ng-container *ngIf="source === 'orders'">
                <mat-button-toggle *ngFor="let preset of dateRangePresets | keyvalue: preservePresetOrder"
                                  [value]="preset.value">
                        {{ 'orders.grid.dateRange.' + preset.value | translate }}
                </mat-button-toggle>
            </ng-container>
            <ng-container *ngIf="source === 'scheduledOrders'">
                <mat-button-toggle *ngFor="let preset of dateRangePresetsFuture | keyvalue: preservePresetOrder"
                                   [value]="preset.value">
                        {{ 'orders.grid.dateRange.' + preset.value | translate }}
                </mat-button-toggle>
            </ng-container>
        </mat-button-toggle-group>
    </div>
    <div class="calendar">
        <h4>{{ 'orders.grid.dateRange.customDates' | translate }}</h4>
        <mat-form-field>
            <mat-label>{{ 'orders.grid.dateRange.enterDateRange' | translate }}</mat-label>
            <mat-date-range-input>
                <input matStartDate
                       readonly
                       [value]="tempDateRange.start || dateRange.start" />
                <input matEndDate
                       readonly
                       [value]="tempDateRange.end || dateRange.end" />
            </mat-date-range-input>
        </mat-form-field>
        <mat-calendar [selected]="tempDateRange || dateRange"
                      (selectedChange)="setTempDateRange($event)"
                      [maxDate]="maxDate"
                      [minDate]="minDate">
        </mat-calendar>
    </div>
    <div class="actions">
        <txp-button [style]="buttonStyle.SECONDARY"
                    [size]="buttonSize.SMALL"
                    (click)="cancelDateRangeChange()">
            {{ 'form.button.cancel' | translate }}
        </txp-button>
        <txp-button [disabled]="!tempDateRange.end"
                    [style]="buttonStyle.PRIMARY"
                    [size]="buttonSize.SMALL"
                    (click)="confirmDateRangeChange()">
            {{ 'form.button.select' | translate }}
        </txp-button>
    </div>
    </div>
  </mat-menu>
</mat-form-field>
